import { render, staticRenderFns } from "./ContractLicenceRedirect.vue?vue&type=template&id=37136401&scoped=true&"
import script from "./ContractLicenceRedirect.vue?vue&type=script&lang=js&"
export * from "./ContractLicenceRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37136401",
  null
  
)

export default component.exports